import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TravelMovementsExportData } from '../types';
import { LoadingButton } from '@mui/lab';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import FormFields from './FormFields';
import { travelMovementsExportSchema } from '../schema';
import { TRAVEL_MOVEMENTS_EXPORT_SAVE } from 'RestAPIs/endpoints';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';

type Props = {
  rowData: TravelMovementsExportData;
  handleClose: () => void;
};

const TravelMovementsExportForm = ({ rowData, handleClose }: Props) => {
  const { t } = useTranslation('common');

  const { mutateAsync: saveForm, isLoading } = useUpdateResource({
    url: TRAVEL_MOVEMENTS_EXPORT_SAVE,
    id: '',
    invalidateQueryKey: ['travelMovementsExport', 'list']
  });

  const methods = useForm<TravelMovementsExportData>({
    defaultValues: travelMovementsExportSchema().cast(rowData),
    resolver: yupResolver(travelMovementsExportSchema())
  });

  const { control, handleSubmit } = methods;

  const onSubmit = async (data: TravelMovementsExportData) => {
    await saveForm(data).then(handleClose);
  };

  return (
    <MultiStepForm methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <FormFields control={control} />
      <MultiStepForm.Actions>
        <LoadingButton
          loading={isLoading}
          type="submit"
          variant="contained"
          autoFocus
          color="primary"
        >
          {t('save')}
        </LoadingButton>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
};

export default TravelMovementsExportForm;
